export default __webpack_public_path__ + "static/media/freedom.a82e134c.png";